import { authenticatedRestClient } from 'helpers/restclient';
import { buildParamsURL } from 'helpers/search';

export default class BuysideSearchService {
	static instance = new BuysideSearchService();

	_endpoints = {
		searchVehicles: '/api/search',
		searchVehiclesUnifiedMarketplace: '/api/v4/search',
		searchPreviewUnifiedMarketplace: `/api/v4/search/preview`,
		searchVehiclesClosedTradeNetwork: '/api/closed_trade_network/search',
		getSavedSearch: (savedSearchId) => `/api/search_filters/${savedSearchId}`,
		getSavedSearchNew: '/api/configurable_search/saved_searches',
		getFilters: '/api/configurable_search',
		deleteSavedSearch: (savedSearchId) => `/api/search_filters/${savedSearchId}`,
		updateSavedSearch: (savedSearchId) => `/api/search_filters/${savedSearchId}`,
		updateSavedSearchOrder: '/api/configurable_search/saved_searches/update_order',
		createSavedSearch: `/api/search_filters/`,
	};

	constructor() {
		this.restClient = authenticatedRestClient;
	}

	buildSearchVehiclesEndpoint = ({ params, closedTradeNetwork, endpoint } = {}) => {
		let baseURL;
		if (endpoint) {
			baseURL = endpoint;
		} else if (closedTradeNetwork) {
			baseURL = this._endpoints.searchVehiclesClosedTradeNetwork;
		} else {
			baseURL = this._endpoints.searchVehiclesUnifiedMarketplace;
		}

		const queryParams = buildParamsURL(params || {});
		return `${baseURL}${queryParams ? `?${queryParams}` : ''}`;
	};

	searchVehicles = ({ params, closedTradeNetwork, cancelToken, endpoint }) => {
		const url = this.buildSearchVehiclesEndpoint({ params, closedTradeNetwork, endpoint });
		return this.restClient.get(url, null, {}, cancelToken);
	};

	searchPreview = (params, cancelToken) => {
		const baseURL = this._endpoints.searchPreviewUnifiedMarketplace;
		return this.restClient.get(`${baseURL}?${buildParamsURL(params)}`, null, {}, cancelToken);
	};

	getSavedSearchesNew = ({ context, source_tab }, cancelToken) => {
		let endpointUrl = this._endpoints.getSavedSearchNew;

		return this.restClient.get(`${endpointUrl}?${buildParamsURL({ context, source_tab })}`, null, {}, cancelToken);
	};

	getSavedSearch = async (savedSearchId, cancelToken) => {
		if (savedSearchId) {
			let baseURL = this._endpoints.getSavedSearch(savedSearchId);
			const savedSearch = await this.restClient.get(baseURL, null, {}, cancelToken);
			const searchFilters = savedSearch?.data?.data?.search_filters;
			if (searchFilters?.length) return searchFilters[0];
		}
		return null;
	};

	getFilters = async ({ context, sourceTab, cancelToken }) => {
		const endpoint = this._endpoints.getFilters;
		return this.restClient.get(endpoint, { context, source_tab: sourceTab }, {}, cancelToken);
	};

	deleteSavedSearch = async (savedSearchId, cancelTOken) => {
		return this.restClient.delete(this._endpoints.deleteSavedSearch(savedSearchId), {}, cancelTOken);
	};

	updateSavedSearch = async (savedSearchId, changes, cancelToken) => {
		return this.restClient.put(this._endpoints.updateSavedSearch(savedSearchId), changes, {}, cancelToken);
	};

	updateSavedSearchOrder = async (savedSearchIds, cancelToken) => {
		return this.restClient.patch(
			this._endpoints.updateSavedSearchOrder,
			{ saved_search_ids: savedSearchIds },
			{},
			cancelToken,
		);
	};

	createSavedSearch = async (savedSearch, cancelToken) => {
		return this.restClient.post(this._endpoints.createSavedSearch, savedSearch, {}, cancelToken);
	};
}
